import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const ContactDetailsPanel = ({ selectedConversation }) => {
  const [followUpDate, setFollowUpDate] = useState('');
  const [followUpTime, setFollowUpTime] = useState('');
  const [followUpType, setFollowUpType] = useState('');
  const [notes, setNotes] = useState('');

  const clientDetails = {
    id: 1,
    name: 'أحمد محمد السعيد',
    phone: '+966 50 123 4567',
    email: 'ahmed.alsaeed@email.com',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_124f29a0c-1763295911925.png",
    imageAlt: 'صورة شخصية لرجل عربي يرتدي بدلة رسمية زرقاء داكنة مع قميص أبيض وربطة عنق',
    status: 'عميل نشط',
    joinDate: '2025-12-15',
    totalInteractions: 24,
    lastContact: new Date(Date.now() - 300000),
    preferredContact: 'واتساب',
    propertyInterests: [
    { id: 1, name: 'فيلا فاخرة - حي النرجس', status: 'نشط' },
    { id: 2, name: 'شقة استثمارية - حي الياسمين', status: 'قيد المتابعة' }],

    tags: ['عميل مميز', 'مهتم بالفلل', 'دفع نقدي']
  };

  const followUpHistory = [
  {
    id: 1,
    date: new Date(Date.now() - 86400000),
    type: 'مكالمة هاتفية',
    status: 'مكتمل',
    notes: 'تم الاتفاق على موعد المعاينة'
  },
  {
    id: 2,
    date: new Date(Date.now() - 172800000),
    type: 'رسالة واتساب',
    status: 'مكتمل',
    notes: 'إرسال تفاصيل العقار'
  },
  {
    id: 3,
    date: new Date(Date.now() - 259200000),
    type: 'بريد إلكتروني',
    status: 'مكتمل',
    notes: 'إرسال العرض الأولي'
  }];


  const templates = [
  {
    id: 1,
    name: 'رسالة ترحيب',
    content: 'أهلاً وسهلاً بك، نشكرك على اهتمامك بخدماتنا العقارية'
  },
  {
    id: 2,
    name: 'تأكيد موعد',
    content: 'تم تأكيد موعد المعاينة يوم [التاريخ] الساعة [الوقت]'
  },
  {
    id: 3,
    name: 'متابعة بعد المعاينة',
    content: 'نأمل أن تكون المعاينة قد نالت إعجابك، نحن في انتظار ردك'
  },
  {
    id: 4,
    name: 'عرض خاص',
    content: 'لدينا عرض خاص على العقار الذي أبديت اهتمامك به'
  }];


  const followUpTypeOptions = [
  { value: 'call', label: 'مكالمة هاتفية' },
  { value: 'whatsapp', label: 'رسالة واتساب' },
  { value: 'email', label: 'بريد إلكتروني' },
  { value: 'meeting', label: 'اجتماع شخصي' }];


  const handleScheduleFollowUp = () => {
    if (followUpDate && followUpTime && followUpType) {
      console.log('Scheduling follow-up:', { followUpDate, followUpTime, followUpType, notes });
      setFollowUpDate('');
      setFollowUpTime('');
      setFollowUpType('');
      setNotes('');
    }
  };

  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('ar-SA', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="h-full flex flex-col bg-card overflow-y-auto">
      {/* Client Info */}
      <div className="p-4 md:p-6 border-b border-border">
        <div className="text-center mb-4 md:mb-6">
          <Image
            src={clientDetails?.image}
            alt={clientDetails?.imageAlt}
            className="w-20 h-20 md:w-24 md:h-24 rounded-full object-cover mx-auto mb-3 md:mb-4" />

          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-1 md:mb-2">
            {clientDetails?.name}
          </h3>
          <span className="inline-block px-3 py-1 rounded-full bg-success/10 text-success text-xs md:text-sm font-caption">
            {clientDetails?.status}
          </span>
        </div>

        <div className="space-y-2 md:space-y-3">
          <div className="flex items-center gap-2 md:gap-3 text-sm md:text-base">
            <Icon name="Phone" size={16} className="text-primary" />
            <span className="text-foreground">{clientDetails?.phone}</span>
          </div>
          <div className="flex items-center gap-2 md:gap-3 text-sm md:text-base">
            <Icon name="Mail" size={16} className="text-primary" />
            <span className="text-foreground truncate">{clientDetails?.email}</span>
          </div>
          <div className="flex items-center gap-2 md:gap-3 text-sm md:text-base">
            <Icon name="MessageCircle" size={16} className="text-primary" />
            <span className="text-foreground">{clientDetails?.preferredContact}</span>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 md:gap-3 mt-4 md:mt-6">
          <div className="p-2 md:p-3 rounded-lg bg-muted text-center">
            <p className="text-lg md:text-xl font-heading font-semibold text-foreground">
              {clientDetails?.totalInteractions}
            </p>
            <p className="text-xs md:text-sm text-muted-foreground font-caption">تفاعل</p>
          </div>
          <div className="p-2 md:p-3 rounded-lg bg-muted text-center">
            <p className="text-lg md:text-xl font-heading font-semibold text-foreground">2</p>
            <p className="text-xs md:text-sm text-muted-foreground font-caption">عقار مهتم</p>
          </div>
        </div>

        <div className="flex flex-wrap gap-1.5 md:gap-2 mt-3 md:mt-4">
          {clientDetails?.tags?.map((tag, index) =>
          <span
            key={index}
            className="px-2 md:px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-caption">

              {tag}
            </span>
          )}
        </div>
      </div>
      {/* Property Interests */}
      <div className="p-4 md:p-6 border-b border-border">
        <h4 className="text-sm md:text-base font-heading font-semibold text-foreground mb-3 md:mb-4">
          العقارات المهتم بها
        </h4>
        <div className="space-y-2 md:space-y-3">
          {clientDetails?.propertyInterests?.map((property) =>
          <div
            key={property?.id}
            className="p-2 md:p-3 rounded-lg bg-muted hover:bg-muted/80 transition-colors cursor-pointer">

              <div className="flex items-center justify-between mb-1">
                <span className="text-xs md:text-sm font-medium text-foreground">
                  {property?.name}
                </span>
                <Icon name="ExternalLink" size={14} className="text-primary" />
              </div>
              <span className="text-xs text-muted-foreground font-caption">{property?.status}</span>
            </div>
          )}
        </div>
      </div>
      {/* Follow-up Scheduler */}
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-2 mb-3 md:mb-4">
          <Icon name="Calendar" size={18} className="text-primary" />
          <h4 className="text-sm md:text-base font-heading font-semibold text-foreground">
            جدولة متابعة
          </h4>
        </div>

        <div className="space-y-3 md:space-y-4">
          <Input
            type="date"
            label="التاريخ"
            value={followUpDate}
            onChange={(e) => setFollowUpDate(e?.target?.value)} />

          <Input
            type="time"
            label="الوقت"
            value={followUpTime}
            onChange={(e) => setFollowUpTime(e?.target?.value)} />

          <Select
            label="نوع المتابعة"
            options={followUpTypeOptions}
            value={followUpType}
            onChange={setFollowUpType}
            placeholder="اختر نوع المتابعة" />

          <Input
            type="text"
            label="ملاحظات"
            placeholder="أضف ملاحظات..."
            value={notes}
            onChange={(e) => setNotes(e?.target?.value)} />

          <Button
            variant="default"
            fullWidth
            onClick={handleScheduleFollowUp}
            disabled={!followUpDate || !followUpTime || !followUpType}
            iconName="Plus"
            iconPosition="left">

            إضافة متابعة
          </Button>
        </div>
      </div>
      {/* Follow-up History */}
      <div className="p-4 md:p-6 border-b border-border">
        <h4 className="text-sm md:text-base font-heading font-semibold text-foreground mb-3 md:mb-4">
          سجل المتابعات
        </h4>
        <div className="space-y-2 md:space-y-3">
          {followUpHistory?.map((item) =>
          <div key={item?.id} className="p-2 md:p-3 rounded-lg bg-muted">
              <div className="flex items-center justify-between mb-1 md:mb-2">
                <span className="text-xs md:text-sm font-medium text-foreground">{item?.type}</span>
                <span className="px-2 py-0.5 rounded-full bg-success/10 text-success text-xs font-caption">
                  {item?.status}
                </span>
              </div>
              <p className="text-xs md:text-sm text-muted-foreground mb-1">{item?.notes}</p>
              <span className="text-xs text-muted-foreground font-caption">
                {formatDate(item?.date)}
              </span>
            </div>
          )}
        </div>
      </div>
      {/* Templates */}
      <div className="p-4 md:p-6">
        <h4 className="text-sm md:text-base font-heading font-semibold text-foreground mb-3 md:mb-4">
          قوالب الرسائل
        </h4>
        <div className="space-y-2">
          {templates?.map((template) =>
          <button
            key={template?.id}
            className="w-full p-2 md:p-3 rounded-lg bg-muted hover:bg-primary hover:text-primary-foreground transition-all duration-250 text-right">

              <div className="flex items-center justify-between mb-1">
                <span className="text-xs md:text-sm font-medium">{template?.name}</span>
                <Icon name="Copy" size={14} />
              </div>
              <p className="text-xs line-clamp-2 opacity-80">{template?.content}</p>
            </button>
          )}
        </div>
      </div>
    </div>);

};

export default ContactDetailsPanel;